<template>
  <div :style="cssVars">
    <page-layout
      :noSideBar="false"
      :headerBackgroundColor="cssVars['--outcome-primary']"
    >
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row items-center">
          <q-select
            v-model="reportType"
            :options="[
              { label: 'Data Reporting', path: '/data' },
              { label: 'Story Board', path: '/storyBoard' },
              // { label: 'Scale', path: '/scaleReporting' },
            ]"
            filled
            :style="`width: 200px;
                      background-color: rgba(0,0, 0, 0.3);
                      border-radius: 5px;
                      `"
            dense
            dropdown-icon="mdi-chevron-down"
            bg-color="white"
            color="black"
            option-label="label"
            option-value="label"
            @input="reportTypeChanged"
          ></q-select>
          <span v-if="reportType" class="headerText text-white q-mx-sm">
            For
          </span>
          <sustainability-dropdown
            v-if="reportType"
            :model="outcome"
            class="q-ml-sm"
            :style="`width: 260px;
                      background-color: ${
                        selectedOutcome &&
                        selectedOutcome.id == $route.params.outcomeID
                          ? cssVars['--outcome-secondary']
                          : 'rgba(0,0, 0, 0.3)'
                      };
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            @input="selectOutcome"
          ></sustainability-dropdown>
          <!-- <div id="whiteFieldAppend" class="q-ml-sm">
            <q-select
              v-model="selectedCategory"
              :options="outcomesCategories"
              :style="`width: 250px;
                      background-color: ${
                        selectedOutcome &&
                        selectedOutcome.id == $route.params.outcomeID
                          ? cssVars['--outcome-secondary']
                          : 'rgba(0,0, 0, 0.3)'
                      };
                      border-radius: 5px;
                      `"
              color="white"
              dropdown-icon="mdi-chevron-down"
              :label-color="'white'"
              dense
              placeholder="Category"
              class="specialDropdownStyles"
              option-label="name"
              option-value="id"
              emit-value
              map-options
              clearable
            >
              <template v-slot:option="scope">
                <q-item
                  class="bg-white option"
                  v-bind="scope.itemProps"
                  v-on="scope.itemEvents"
                  clickable
                  v-ripple
                >
                  <q-item-section>
                    <q-item-label
                      class="option-label text-black"
                      v-html="scope.opt['name']"
                    >
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div> -->

          <span v-if="reportType" class="headerText text-white q-mx-sm">
            In
          </span>
          <year-picker
            ref="yearPicker"
            label=""
            :bg="`${
              selectedOutcome && selectedOutcome.id == $route.params.outcomeID
                ? cssVars['--outcome-secondary']
                : 'rgba(0,0, 0, 0.3)'
            }`"
            @selectYear="selectYear"
          ></year-picker>
          <div
            class="filterButton cursor-pointer q-px-sm q-py-xs q-mr-sm"
            ref="filterButton"
          >
            <q-icon name="mdi-filter-outline" size="xs"> </q-icon>
            <span class="filtersText">
              Filters {{ filtersCount ? `(${filtersCount})` : "" }}</span
            >
            <q-menu>
              <div
                style="
                  min-width: 600px;
                  max-width: 600px;
                  background-color: #f6f6f6;
                "
                class="q-pa-md"
              >
                <div class="row">
                  <div class="filtersTitle">Filters</div>
                </div>
                <div class="row q-col-gutter-sm q-py-md">
                  <div class="col-auto">
                    <q-card
                      flat
                      class="q-pa-sm filterCardSelector"
                      :class="{
                        active: filterTab == 'category',
                      }"
                      @click="filterTab = 'category'"
                    >
                      Category
                    </q-card>
                  </div>
                  <div class="col-auto">
                    <q-card
                      flat
                      class="q-pa-sm filterCardSelector"
                      :class="{
                        active: filterTab == 'source',
                      }"
                      @click="filterTab = 'source'"
                    >
                      Source
                    </q-card>
                  </div>
                </div>
                <div class="row" v-if="filterTab == 'category'">
                  <div class="filtersTitle">Category</div>
                </div>
                <div
                  class="row q-col-gutter-sm q-py-md"
                  v-if="filterTab == 'category'"
                >
                  <div
                    v-for="(category, index) in outcomesCategories"
                    :key="`categoryFilter_${index}`"
                    class="col-auto"
                  >
                    <q-card
                      flat
                      class="q-pa-sm filterCardSelector"
                      :class="{
                        active: selectedCategory == category.id,
                      }"
                      @click="
                        selectedCategory = category.id;
                        selectedSource = null;
                      "
                    >
                      {{ category.name }}
                      <q-btn
                        v-if="selectedCategory == category.id"
                        icon="mdi-close"
                        @click.stop="
                          selectedCategory = null;
                          selectedSource = null;
                        "
                        dense
                        flat
                        round
                        size="xs"
                      ></q-btn>
                    </q-card>
                  </div>
                </div>
                <div class="row" v-if="filterTab == 'source'">
                  <div class="filtersTitle">Source</div>
                </div>
                <div
                  class="row q-col-gutter-sm q-py-md"
                  v-if="filterTab == 'source' && !sourcesWithDataLoading"
                >
                  <div
                    v-for="(source, index) in sourcesWithData"
                    :key="`sourcesFilter_${index}`"
                    class="col-auto"
                  >
                    <q-card
                      flat
                      class="q-pa-sm filterCardSelector"
                      :class="{
                        active: selectedSource == source.id,
                      }"
                      @click="selectedSource = source.id"
                    >
                      {{ source.name }}
                      <q-btn
                        v-if="selectedSource == source.id"
                        icon="mdi-close"
                        @click.stop="selectedSource = null"
                        dense
                        flat
                        round
                        size="xs"
                      ></q-btn>
                    </q-card>
                  </div>
                </div>
                <!--
                <div
                  class="full-width"
                  style="min-height: 2px; background: #eeeeee"
                ></div>
                <div class="row q-py-md">
                  <div class="filtersTitle">Categories</div>
                </div>
                <div class="row q-col-gutter-md">
                  <div class="col-4">
                    <div class="row">
                      <div class="filtersSubTitle">Difficulty</div>
                    </div>
                    <q-select
                      v-model="selectedDifficultyFilter"
                      :options="filterOptions[2].children"
                      :style="`
                                    background-color: white;
                                    border-radius: 7px;
                                    `"
                      color="white"
                      dropdown-icon="mdi-chevron-down"
                      :label-color="'white'"
                      dense
                      class="specialDropdownStyles"
                      option-label="label"
                      option-value="name"
                      emit-value
                      map-options
                    >
                      <template v-slot:option="scope">
                        <q-item
                          class="bg-white option"
                          v-bind="scope.itemProps"
                          v-on="scope.itemEvents"
                          clickable
                          v-ripple
                        >
                          <q-item-section>
                            <q-item-label
                              class="option-label text-black"
                              v-html="scope.opt['label']"
                            >
                            </q-item-label>
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-4">
                    <div class="row">
                      <div class="filtersSubTitle">Cost</div>
                    </div>
                    <q-select
                      v-model="selectedCostFilter"
                      :options="filterOptions[0].children"
                      :style="`
                                    background-color: white;
                                    border-radius: 7px;
                                    `"
                      color="white"
                      dropdown-icon="mdi-chevron-down"
                      :label-color="'white'"
                      dense
                      class="specialDropdownStyles"
                      option-label="label"
                      option-value="name"
                      emit-value
                      map-options
                    >
                      <template v-slot:option="scope">
                        <q-item
                          class="bg-white option"
                          v-bind="scope.itemProps"
                          v-on="scope.itemEvents"
                          clickable
                          v-ripple
                        >
                          <q-item-section>
                            <q-item-label
                              class="option-label text-black"
                              v-html="scope.opt['label']"
                            >
                            </q-item-label>
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-4">
                    <div class="row">
                      <div class="filtersSubTitle">Impact</div>
                    </div>
                    <q-select
                      v-model="selectedImpactFilter"
                      :options="filterOptions[1].children"
                      :style="`
                                    background-color: white;
                                    border-radius: 7px;
                                    `"
                      color="white"
                      dropdown-icon="mdi-chevron-down"
                      :label-color="'white'"
                      dense
                      class="specialDropdownStyles"
                      option-label="label"
                      option-value="name"
                      emit-value
                      map-options
                    >
                      <template v-slot:option="scope">
                        <q-item
                          class="bg-white option"
                          v-bind="scope.itemProps"
                          v-on="scope.itemEvents"
                          clickable
                          v-ripple
                        >
                          <q-item-section>
                            <q-item-label
                              class="option-label text-black"
                              v-html="scope.opt['label']"
                            >
                            </q-item-label>
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <div class="filtersSubTitle">Area of Business</div>
                    </div>
                    <q-select
                      v-model="selectedImpactFilter"
                      :options="filterOptions[1].children"
                      :style="`
                                    background-color: white;
                                    border-radius: 7px;
                                    `"
                      color="white"
                      dropdown-icon="mdi-chevron-down"
                      :label-color="'white'"
                      dense
                      class="specialDropdownStyles"
                      option-label="label"
                      option-value="name"
                      emit-value
                      map-options
                    >
                      <template v-slot:option="scope">
                        <q-item
                          class="bg-white option"
                          v-bind="scope.itemProps"
                          v-on="scope.itemEvents"
                          clickable
                          v-ripple
                        >
                          <q-item-section>
                            <q-item-label
                              class="option-label text-black"
                              v-html="scope.opt['label']"
                            >
                            </q-item-label>
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                </div> -->
              </div>
            </q-menu>
          </div>
        </div>
      </template>
      <template v-slot:content>
        <div
          class="column"
          v-if="selectedOutcome && report && report.graphable"
        >
          <div class="col q-py-lg">
            <div class="row items-center">
              <!-- <div class="col-auto">
                <q-checkbox
                  :label="`Total ${report.factoredUnit}`"
                  v-model="totalFactoredView"
                ></q-checkbox>
                <q-checkbox
                  :label="`${selectedOutcome.label} Intensity`"
                  v-model="intensityView"
                ></q-checkbox>
                <q-checkbox
                  v-if="report && report.unitTrue"
                  :label="`Total Unit`"
                  v-model="totalUnitView"
                ></q-checkbox>
              </div> -->
              <div class="col"></div>
              <div class="col-auto q-px-sm">
                <div
                  class="row items-center"
                  v-if="
                    !selectedOutcome.positiveLabel ||
                    !selectedOutcome.negativeLabel
                  "
                >
                  <div
                    :style="`min-width: 17px;min-height: 17px; background: #162C47; border-radius: 5px; display: inline-block`"
                    class="q-mx-sm"
                  ></div>
                  Baseline
                  <div
                    :style="`min-width: 17px;min-height: 17px; background: #4AC7E9; border-radius: 5px; display: inline-block`"
                    class="q-mx-sm"
                  ></div>
                  Goal
                  <div
                    :style="`min-width: 17px;min-height: 17px; background: #33A02C; border-radius: 5px; display: inline-block`"
                    class="q-mx-sm"
                  ></div>
                  Annual Projection
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto" style="height: calc(100vh - 300px)">
            <apex-chart
              :ref="`chart`"
              height="100%"
              :options="options"
              :series="series ? series : []"
              :resizeChecking="false"
            >
            </apex-chart>

            <!-- {{ report }} -->
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <div
          class="column full-height full-width sidebar"
          v-if="report && outcome"
        >
          <div class="col-auto q-pa-md" style="height: 109px">
            <div class="row items-center full-height">
              <h3 class="highlight">{{ outcome.label }}</h3>
            </div>
          </div>
          <div class="col-auto q-px-md">
            <q-scroll-area
              style="height: calc(100vh - 185px)"
              :thumb-style="{
                background: '#162c479c',
                opacity: 1,
                width: '8px',
                height: '8px',
                borderRadius: '20px',
              }"
            >
              <div v-if="report.graphable">
                <div class="row">
                  <div class="col-12">
                    <h3 class="text-accent">Total for the year</h3>
                    <h2 class="statMain highlightPrimary">
                      {{ factorCalculation(report.total) | numberFormat }}
                      {{ factorUnit(report.factoredUnit) }}
                    </h2>
                  </div>
                  <div class="col-12">
                    <div class="row q-col-gutter-sm">
                      <div class="col-6 q-py-md">
                        <p class="secondaryStat highlightPrimary">
                          {{
                            factorCalculation(report.annualProjectionFactored)
                              | numberFormat
                          }}
                          {{ factorUnit(report.factoredUnit) }}
                        </p>
                        <p class="secondaryStatHeader">Monthly Average</p>
                      </div>
                      <div class="col-6 q-py-md">
                        <p class="secondaryStat highlightPrimary">
                          {{
                            factorCalculation(
                              report.annualProjectionFactored * 3
                            ) | numberFormat
                          }}
                          {{ factorUnit(report.factoredUnit) }}
                        </p>
                        <p class="secondaryStatHeader">Quarterly Average</p>
                      </div>
                      <div v-if="report.goal" class="col-12 q-py-sm">
                        <p class="secondaryStatHeader">
                          Goal for {{ selectedYear }} was
                        </p>
                        <p class="secondaryStatDesc">
                          Reduction of
                          <b class="highlightPrimary">{{ outcome.label }}</b> to
                          <b class="highlightPrimary"
                            >{{
                              factorCalculation(report.goal.targetData)
                                | numberFormat
                            }}
                            {{ factorUnit(report.factoredUnit) }}</b
                          >
                          (Reduce {{ report.goal.reducePercent }}% by
                          {{ report.goal.duebyYear }})
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-scroll-area>
          </div>
          <div class="col q-px-md"></div>
        </div>
        <div class="column full-height full-width sidebar" v-else>
          <div class="col-auto q-pa-md" style="height: 109px">
            <div class="row items-center full-height">
              <h3 class="text-accent2">Reporting</h3>
            </div>
          </div>
          <div class="col-auto q-px-md">
            <q-scroll-area
              style="height: calc(100vh - 185px)"
              :thumb-style="{
                background: '#162c479c',
                opacity: 1,
                width: '8px',
                height: '8px',
                borderRadius: '20px',
              }"
            >
              <p>
                Welcome to reporting, please use the filters to choose what kind
                of reports you want to view, you must select from a specific
                outcome.
              </p>
              <p>
                You may change the dates to view historical reports but the
                default will be set to the current year.
              </p>
              <p>
                Due to the nature of the data - some types of reporting may not
                be available for some outcomes.
              </p>
            </q-scroll-area>
          </div>
          <div class="col q-px-md"></div>
        </div>
      </template>
    </page-layout>

    <q-dialog v-model="displayFilterPopup" persistent>
      <q-card
        class="card q-mx-auto"
        style="min-width: 610px; max-width: 610px"
        :style="cssVars"
      >
        <div class="row justify-between items-center q-px-md bg-accent2">
          <div class="text-white" style="font-size: 1rem; font-weight: 700">
            Please Select Filters
          </div>
          <q-btn
            icon="mdi-close"
            flat
            round
            text-color="white"
            @click="displayFilterPopup = false"
          >
          </q-btn>
        </div>
        <div class="row q-pa-md">
          <div class="col-12 text-accent">
            <b
              >You must select a common unit to view your data report for this
              Outcome.</b
            >
          </div>
          <div class="col-12">
            You can change this at any time by using the Filter button
          </div>
          <div class="col-12 text-center q-mt-xl">
            <q-btn
              flat
              class="bg-accent text-white"
              style="width: 300px"
              no-caps
              @click="openFilterFromPopup"
            >
              Open Filter
            </q-btn>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import YearPicker from "@/components/generalComponents/yearPicker.vue";
import PageLayout from "@/components/pageLayout/pageLayout.vue";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import apexChart from "@/components/wrappers/apexCharts/apexChart.vue";
import { getCSSVars } from "@/functions/cssVars";
export default {
  components: {
    YearPicker,
    PageLayout,
    SustainabilityDropdown,
    apexChart,
  },

  computed: {
    ...mapGetters({
      outcomesList: "outcomes/listDataOutcomes",
      outcomeReferenceList: "outcomes/keyReferenceList",
      currentUserData: "auth/currentUserData",
      outcomePlan: "businessOutcomePlans/current",
      outcomePlanLoading: "businessOutcomePlans/currentLoading",
      selectedOutcome: "general/selectedOutcome",
      report: "reports/data/report",
      reportLoading: "reports/data/reportLoading",

      outcomesCategories: "outcomes/categories/listForData",
      sourcesWithData: "sources/sourcesWithData",
      sourcesWithDataLoading: "sources/sourcesWithDataLoading",
    }),
    cssVars() {
      let outcome = this.selectedOutcome;
      return getCSSVars(outcome);
    },
    filtersCount() {
      if (this.selectedSource) {
        return 2;
      }

      if (this.selectedCategory) {
        return 1;
      }

      return 0;
    },
    options: function () {
      let annotations =
        this.selectedOutcome.positiveLabel && this.selectedOutcome.negativeLabel
          ? {}
          : {
              yaxis: [
                {
                  y:
                    this.report && this.report.baseline
                      ? this.report.baseline
                      : 0,
                  height: 20,
                  borderWidth: 5,
                  borderColor: "#162C47",
                  strokeDashArray: 0,
                },
                {
                  y:
                    this.report && this.report.annualProjectionFactored
                      ? this.factorCalculation(
                          this.report.annualProjectionFactored
                        )
                      : 0,
                  strokeDashArray: 0,
                  height: 20,
                  borderWidth: 5,
                  borderColor: "#33A02C",
                },
                {
                  y: this.report && this.report.target ? this.report.target : 0,
                  height: 20,
                  borderWidth: 5,
                  borderColor: "#4AC7E9",
                  strokeDashArray: 10,
                },
              ],
            };
      return {
        chart: {
          type: "area",
          id: "dataReportChart",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.selectedData = this.series[config.dataPointIndex];
            },
          },
        },
        colors: [
          this.cssVars["--outcome-secondary"],
          this.cssVars["--outcome-primary"],
        ],
        annotations: annotations,
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          padding: {
            right: 30,
            left: 20,
          },
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return val.toFixed(2).toLocaleString("en-US");
            },
          },
        },
      };
    },
  },

  data: () => ({
    outcome: null,
    reportType: "Data Reporting",
    selectedYear: null,

    totalFactoredView: true,
    intensityView: false,
    totalUnitView: false,

    series: null,

    selectedData: null,

    // filters
    filterTab: "category",

    selectedCategory: null,
    selectedSource: null,

    displayFilterPopup: false,
  }),
  watch: {
    selectedOutcome: function () {
      this.initSelectedOutcome();
      this.selectedCategory = null;
      this.selectedSource = null;
    },
    selectedYear: function () {
      this.initSelectedOutcome();
    },
    $route: function () {
      this.handleRoute();
    },
    report: function () {
      this.handleChartData();
    },
    selectedCategory: function () {
      this.loadDataReport();
      this.loadSourcesWithData();
    },
    selectedSource: function () {
      this.loadDataReport();
    },
  },
  async mounted() {
    this.handleRoute();
    if (this.selectedOutcome) {
      this.initSelectedOutcome();
      this.handleChartData;
    }

    if (!this.$route.params.year && this.$route.params.outcomeID) {
      this.selectYear(this.$moment().format("YYYY"));
    } else {
      this.selectedYear = this.$route.params.year;
    }
  },
  methods: {
    getCSSVars: getCSSVars,
    initSelectedOutcome() {
      this.outcome = this.selectedOutcome;
      this.loadDataReport(true);
      this.$store.dispatch(
        "outcomes/categories/loadAllByOutcomesID",
        this.selectedOutcome.id
      );
    },
    handleRoute() {
      if (this.$route.params.outcomeID) {
        this.loadOutcome();
        // this.loadDataReport();
      } else {
        this.$store.dispatch("general/updateSelectedOutcome", null);
      }
    },
    async loadOutcome() {
      if (this.outcomesList.length < 1) {
        await this.$store.dispatch("outcomes/loadAll");
      }
      let outcome = this.outcomeReferenceList[this.$route.params.outcomeID];
      this.$store.dispatch("general/updateSelectedOutcome", outcome);
    },
    selectOutcome(outcome) {
      let route;
      this.filterTab = "category";
      this.selectedCategory = null;
      this.selectedSource = null;

      if (this.$route.params.outcomeID) {
        let split = this.$route.path.split(
          `/outcome/${this.$route.params.outcomeID}`
        );
        route = `${split[0]}/outcome/${outcome.id}${split[1]}`;
      } else {
        let split = this.$route.path.split(`/outcome`);
        route = route = `${split[0]}/outcome/${outcome.id}`;
      }
      this.$router.push(route);

      setTimeout(() => {
        if (!this.$route.params.year) {
          this.selectYear(this.$moment().format("YYYY/"));
        }
      }, 100);
    },
    loadDataReport(graphablePopup = false) {
      if (this.selectedYear) {
        this.$store
          .dispatch("reports/data/loadReport", {
            outcomes_id: this.outcome.id,
            year: this.selectedYear,
            category_id: this.selectedCategory,
            source_id: this.selectedSource,
          })
          .then(() => {
            setTimeout(() => {
              if (this.report && !this.report.graphable && graphablePopup) {
                this.displayFilterPopup = true;
              }
            }, 100); //Weird Bug that causes the check to pass even when it should fail, unless a timeout is set.
          });
      }
    },
    selectYear(val) {
      this.selectedYear = val.split("/")[0];
      let route;
      if (this.$route.params.year) {
        let split = this.$route.path.split(`/year/${this.$route.params.year}`);
        route = `${split[0]}/year/${this.selectedYear}${split[1]}`;
      } else {
        let split = this.$route.path.split(`/year`);
        route = route = `${split[0]}/year/${this.selectedYear}`;
      }

      this.$router.push(route);
    },

    // Handle Chart Data
    handleChartData() {
      let series = [
        {
          name: this.factorUnit(this.report.factoredUnit),
          data: [],
        },
      ];
      if (
        this.selectedOutcome.negativeLabel &&
        this.selectedOutcome.positiveLabel
      ) {
        series.push({
          name: `${this.selectedOutcome.positiveLabel} (${this.factorUnit(
            this.report.factoredUnit
          )})`,
          data: [],
        });
        series[0].name = `${
          this.selectedOutcome.negativeLabel
        } (${this.factorUnit(this.report.factoredUnit)})`;
      }

      if (this.report && this.report.data) {
        this.report.data.forEach((data) => {
          series[0].data.push({
            x: this.$moment(data.date).format("MMM"),
            y: data.factoredValueNegative
              ? this.factorCalculation(data.factoredValueNegative)
              : data.unitValueNegative,
          });
          if (
            this.selectedOutcome.negativeLabel &&
            this.selectedOutcome.positiveLabel
          ) {
            series[1].data.push({
              x: this.$moment(data.date).format("MMM"),
              y: data.factoredValuePositive
                ? this.factorCalculation(data.factoredValuePositive)
                : data.unitValuePositive,
            });
          }
        });
      }

      this.series = series;
    },
    reportTypeChanged(val) {
      let route = this.$route.path.split("/data");
      this.$router.push(`${route[0]}${val.path}${route[1]}`);
    },
    factorCalculation(data) {
      if (this.selectedOutcome && this.selectedOutcome.factorMultiplier) {
        return data * this.selectedOutcome.factorMultiplier;
      } else {
        return data;
      }
    },
    factorUnit(data) {
      if (this.selectedOutcome && this.selectedOutcome.factorUnitDisplay) {
        return this.selectedOutcome.factorUnitDisplay;
      } else {
        return data;
      }
    },
    loadSourcesWithData() {
      this.$store.dispatch("sources/loadAllWithData", {
        outcomes_id: this.selectedOutcome.id,
        type: "data",
        category_id: this.selectedCategory,
        year: this.selectedYear,
      });
    },
    openFilterFromPopup() {
      this.displayFilterPopup = false;
      this.$refs.filterButton.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  h3 {
    font-weight: 800;
    font-size: 1.3rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    margin: 10px 0px;
  }

  .statMain {
    font-weight: 900;
    font-size: 1.5rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    margin: 10px 0px;
  }

  .secondaryStat {
    font-weight: 900;
    font-size: 0.9rem;
    line-height: 1.2rem;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    margin: 0;
  }
  .secondaryStatHeader {
    font-weight: 900;
    font-size: 0.6rem;
    line-height: 1rem;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent;
    margin: 0;
  }

  .secondaryStatDesc {
    font-size: 0.8rem;
    line-height: 1rem;
  }
}

.content {
  h4 {
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }
}

.headerText {
  font-weight: 400;
  font-size: 20px;
}

.questionTitle {
  font-weight: 400;
  font-size: 30px;
}

.button-bg {
  background-color: var(--outcome-secondary);
}

.button-text {
  font-weight: 700;
  font-size: 11.6054px;
}

.option-label {
  font-weight: 400;
  font-size: 13px;
}

.filterButton {
  background-color: #f6f6f6;
  height: 40px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
}

.filtersText {
  font-weight: 600;
  font-size: 14px;
}

.filtersTitle {
  font-size: 1rem;
  font-weight: 700;
  color: $accent2;
}

.filterCardSelector {
  // background: orange;
  border-radius: 7px;
  font-weight: 700;
  color: $accent2;
  font-size: 0.8rem;
  transition: all 0.15s ease-in-out;

  &.active {
    background: $primary !important;
    color: white;
  }

  &:hover {
    background: #eeeeee;
    cursor: pointer;
  }
}
</style>

<style lang="scss">
#whiteFieldAppend {
  .q-field__native {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: white !important;
    margin-left: 10px;
  }
  .q-field__append {
    color: white !important;
  }

  .q-item__label {
    color: black !important;
  }
}
</style>
